
import { Injectable, Injector } from "@angular/core";
import { SubscriptionPlateformService } from "./subscription-plateform.service";
import { ESubscriptionType } from "../enum/e-subscription-type";
import { SubscriptionService } from "./subscription.service";

@Injectable({
    providedIn: 'root'
  })
export class SubscriptionFactoryService {

    constructor(private injector : Injector){

    }

    create(type : ESubscriptionType) : SubscriptionService {

        let subscriptionService = null;

        if(type == ESubscriptionType.Plateform){
          subscriptionService = this.injector.get(SubscriptionPlateformService);
        }
        else{
            throw new Error("No subscriptionService for this Type ! ");
        }

        return subscriptionService;
    }

}
